import { ReactNode } from "react";
import SiteNavbar from "@/components/SiteNavbar";
import SiteFooter from "@/components/SiteFooter";
import WhatsAppButton from "@/components/WhatsAppButton";

const SiteLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteNavbar />
      <main className="flex-1 pt-[72px]">{children}</main>
      <SiteFooter />
      <WhatsAppButton />
    </div>
  );
};

export default SiteLayout;
